/**
 * Fixed product catalogue of cancellation motives — the wire vocabulary is the OPDON enum
 * member NAME. The catalogue is not tenant-configurable, so it is code-level on both sides.
 */
export const TAX_RECEIPT_CANCELLATION_REASON_CODES = [
    "IncorrectAmount",
    "WrongDonor",
    "IncorrectDonorAddress",
    "DuplicateEntry",
    "Other",
];
